import React, { useEffect, useRef, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { ErrorMessage } from '@hookform/error-message';
import {
  Button,
  Card,
  CardBody,
  CardSubtitle,
  CardTitle,
  Col,
  Form,
  FormGroup,
  Input,
  Modal,
  ModalBody,
  Row
} from 'reactstrap';

import { buttonStyle } from 'components/Containers/ConfigurationContainer/components/utils';
import FlexSelect from 'components/Inputs/FlexSelect';
import { getStateConversation } from 'utils/fuctions/getStateConversation';
import QueueService from '../../../../../../../../Queue/service';
import { useSocketConversationChatTs } from '../../../../../../../../../hooks/useSocketConversationChatTs';
import UserService from '../../../../../../../../../views/User/service';
import { hooks } from '../../../../../../../../../hooks';
const sortAgentsByAlphabeticalOrder = (agents) => {
  return agents?.sort((a, b) => {
    if (a.name.toLowerCase() < b.name.toLowerCase()) return -1;
    if (a.name.toLowerCase() > b.name.toLowerCase()) return 1;
    return 0;
  });
};

const TransferConversation = ({
  name,
  tooltipTitle = '',
  id,
  conversation,
  isCurrentAgentsLogged
}) => {
  const { getQueuesChat } = hooks.useQueueContentChatContext();
  const { socketChatTS, emitEventTransferChatToQueue } =
    hooks.useSocketConversationChatTs();

  const { control, handleSubmit, errors, setValue } = useForm();
  const [isOpen, setIsOpen] = useState(false);
  const [queues, setQueues] = useState([]);
  const [isTransferByAgentEspecific, setInsTransferByAgentEspecific] =
    useState(false);
  const systemConfiguration = useSelector((state) => state.systemConfiguration);
  const [
    isCurrentAgentsLoggedWithoutTheCurrentAgent,
    setIsCurrentAgentsLoggedWithoutTheCurrentAgent
  ] = useState([]);
  const [
    isCurrentAgentsLoggedWithTheCurrentAgent,
    setIsCurrentAgentsLoggedWithTheCurrentAgent
  ] = useState([]);
  const [showUserOff, setShowUserOff] = useState(false);
  const prevConversationRef = useRef(null);
  const prevIdRef = useRef(null);
  const userState = useRef('DDD não definido');
  const [transferToSelf, setTransferToSelf] = useState(false);

  useEffect(() => {
    if (isOpen) {
      prevConversationRef.current = conversation;
      prevIdRef.current = id;
      userState.current =
        (conversation?.cliente?.telefone &&
          getStateConversation(conversation.cliente?.telefone)) ||
        'DDD não definido';
    }
  }, [isOpen]);

  useEffect(() => {
    if (isOpen) {
      if (isCurrentAgentsLogged) {
        const agents = getAgentsByConversation(
          sortAgentsByAlphabeticalOrder(isCurrentAgentsLogged)
        );
        setIsCurrentAgentsLoggedWithoutTheCurrentAgent(agents);
      }
      getQueuesChat()
        .then((response) => {
          setQueues([...response]);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [isOpen]);

  const getAgentsByConversation = (agents) => {
    if (
      conversation &&
      prevConversationRef.current?.atendente &&
      prevConversationRef.current?.atendente?.id_postgres
    ) {
      return agents.filter(
        (agent) =>
          agent.login !== prevConversationRef.current?.atendente?.id_postgres
      );
    }
    return agents;
  };

  useEffect(() => {
    const agents = getAgentsByConversation(
      sortAgentsByAlphabeticalOrder(isCurrentAgentsLogged)
    );
    setIsCurrentAgentsLoggedWithoutTheCurrentAgent(agents);
  }, [isCurrentAgentsLogged]);

  useEffect(() => {
    if (isTransferByAgentEspecific) {
      if (showUserOff) {
        getAllAgents().then((agentsResponse) => {
          const agents = getAgentsByConversation(agentsResponse);
          setIsCurrentAgentsLoggedWithoutTheCurrentAgent(agents);
        });
        return;
      }
      if (isCurrentAgentsLogged) {
        const agents = getAgentsByConversation(
          sortAgentsByAlphabeticalOrder(isCurrentAgentsLogged)
        );
        setIsCurrentAgentsLoggedWithoutTheCurrentAgent(agents);
        return;
      }
    }
  }, [
    isCurrentAgentsLogged,
    isTransferByAgentEspecific,
    conversation,
    showUserOff
  ]);

  useEffect(() => {
    if (transferToSelf) {
      const agentsWithoutCurrentAgent = isCurrentAgentsLogged.filter(
        (agent) => agent.login === localStorage.getItem('login')
      );

      setIsCurrentAgentsLoggedWithTheCurrentAgent(agentsWithoutCurrentAgent);
    }
  }, [transferToSelf]);

  const getAllAgents = async () => {
    const agents = await UserService.getAll();
    return sortAgentsByAlphabeticalOrder(agents?.data?.data);
  };

  const toggleModal = () => {
    setIsOpen(!isOpen);
  };

  const onSubmit = async (data) => {
    try {
      if (isTransferByAgentEspecific) {
        let atendente;
        let agentFilter = {};

        if (transferToSelf) {
          agentFilter = isCurrentAgentsLoggedWithTheCurrentAgent.find(
            (agent) => agent.login === localStorage.getItem('login')
          );
          atendente = {
            name: agentFilter.name || localStorage.getItem('name'),
            login: agentFilter.login || localStorage.getItem('login'),
            id_socket_atendente: agentFilter.socket_id || ''
          };
        } else {
          agentFilter = isCurrentAgentsLoggedWithoutTheCurrentAgent.find(
            (agent) => data?.user === agent.login
          );

          atendente = {
            name: agentFilter.name,
            login: agentFilter.login,
            id_socket_atendente: agentFilter.socket_id
          };
        }

        socketChatTS.emit('transferir_conversa_atendente', {
          id: prevIdRef.current,
          atendente,
          responsavelPelaTransferencia: {
            name: localStorage.getItem('name'),
            login: localStorage.getItem('login')
          }
        });
      } else {
        emitEventTransferChatToQueue({
          chatId: prevIdRef.current,
          queueId: data.fila,
          subject: data?.assunto,
          observation: data?.observacao,
          sector: data?.setor
        });
      }
      toggleModal();
    } catch (err) {
      const { data } = err.response;
      toast.error(data.message || 'Erro ao transferir conversa!', {
        autoClose: 3000,
        closeOnClick: true
      });
    }
  };

  const errorFormMessage = (message) => (
    <p style={{ color: 'red' }}>{message}</p>
  );

  return (
    <>
      <Button
        size="sm"
        color="primary"
        title={tooltipTitle}
        onClick={toggleModal}
      >
        <i className="fas fa-random"></i>
      </Button>
      <Modal
        className="modal-dialog-centered"
        isOpen={isOpen}
        toggle={toggleModal}
      >
        <div className="modal-header">
          <h6 className="modal-title" id="modal-title-default">
            {name}
          </h6>
          <button
            aria-label="Close"
            className="close"
            data-dismiss="modal"
            type="button"
            onClick={toggleModal}
          >
            <span aria-hidden={true}>×</span>
          </button>
        </div>
        <ModalBody>
          <Card style={{ backgroundColor: '#FFFFFF', marginTop: '-35px' }}>
            <CardBody>
              <CardTitle tag="h4">
                Cliente:{' '}
                {prevConversationRef.current?.cliente?.nome || 'Não informado'}
              </CardTitle>
              <CardSubtitle tag="h5" className="mb-3 text-muted">
                <Row>
                  <Col md="6" title="CPF do cliente">
                    <i
                      className="fas fa-id-card"
                      style={{ color: '#5bc0de' }}
                    ></i>
                    -{' '}
                    {prevConversationRef.current?.cliente?.cpf ||
                      'Não informado'}
                  </Col>
                  <Col md="6" title="Canal de atendimento">
                    <i
                      className="fas fa-users"
                      style={{ color: '#0275d8' }}
                    ></i>
                    - {prevConversationRef.current?.canal || 'Não reconhecido'}
                  </Col>
                </Row>
                <Row>
                  <Col md="6" title="Telefone do cliente">
                    <i
                      className="fas fa-phone"
                      style={{ color: '#5cb85c' }}
                    ></i>
                    -{' '}
                    {prevConversationRef.current?.cliente?.telefone ||
                      'Não informado'}
                  </Col>
                  <Col md="6" title="Estado">
                    <i className="fas fa-city" style={{ color: '#f0ad4e' }}></i>
                    {prevConversationRef.current?.cliente?.telefone &&
                      ` - Estado : ${userState.current}`}
                  </Col>
                </Row>
                <Row>
                  <Col md="6" title="Email do cliente">
                    <i
                      className="fas fa-envelope-open-text"
                      style={{ color: '#f0ad4e' }}
                    ></i>
                    -{' '}
                    {prevConversationRef.current?.cliente?.email ||
                      'Não informado'}
                  </Col>
                  <Col md="6" title="Atendente">
                    <i className="fas fa-user" style={{ color: '#f0ad4e' }}></i>
                    {prevConversationRef.current?.atendente?.name
                      ? ` - ${prevConversationRef.current?.atendente?.name}`
                      : ' - Não informado'}
                  </Col>
                </Row>
              </CardSubtitle>
            </CardBody>
          </Card>

          <hr style={{ marginTop: '-20px' }} />
          <Form className="needs-validation" onSubmit={handleSubmit(onSubmit)}>
            <Row className="mb-3">
              <Col md="12">
                <FormGroup check>
                  <Input
                    type="checkbox"
                    checked={isTransferByAgentEspecific}
                    onChange={() =>
                      setInsTransferByAgentEspecific(
                        !isTransferByAgentEspecific
                      )
                    }
                  />
                  <label className="form-control-label">
                    Trocar forma de transferência para atendente específico
                  </label>
                </FormGroup>
              </Col>
            </Row>

            {!isTransferByAgentEspecific ? (
              <Row className="mb-3">
                <Col md="12">
                  <label className="form-control-label">Fila*</label>
                  <Controller
                    render={(props) => (
                      <FlexSelect
                        dataOptions={queues}
                        isMulti={false}
                        isClearable={false}
                        value={props.value}
                        valueController={setValue}
                        closeMenuOnSelect={true}
                        isSearchable={true}
                        fieldName="fila"
                        labelName="name"
                        valueName="id"
                      />
                    )}
                    control={control}
                    name="fila"
                    defaultValue=""
                    rules={{ required: 'A fila é obrigatória' }}
                  />
                  <ErrorMessage
                    errors={errors}
                    name="fila"
                    render={({ message }) => errorFormMessage(message)}
                  />
                </Col>
              </Row>
            ) : (
              <>
                <Row className="mb-3">
                  <Col md="12">
                    <FormGroup check>
                      <Input
                        type="checkbox"
                        checked={showUserOff}
                        onChange={() => setShowUserOff(!showUserOff)}
                      />
                      <label className="form-control-label">
                        Transferir para todos os atendentes
                      </label>
                    </FormGroup>
                  </Col>
                </Row>

                <Row className="mb-3">
                  <Col md="12">
                    <FormGroup check>
                      <Input
                        type="checkbox"
                        checked={transferToSelf}
                        onChange={() => setTransferToSelf(!transferToSelf)}
                      />
                      <label className="form-control-label">
                        Transferir para si mesmo
                      </label>
                    </FormGroup>
                  </Col>
                </Row>

                {!transferToSelf && (
                  <Row className="mb-3">
                    <Col md="12">
                      <label className="form-control-label">Usuário*</label>
                      <Controller
                        render={(props) => (
                          <FlexSelect
                            dataOptions={
                              isCurrentAgentsLoggedWithoutTheCurrentAgent
                            }
                            isMulti={false}
                            isClearable={true}
                            value={props.value}
                            valueController={setValue}
                            closeMenuOnSelect={true}
                            isSearchable={true}
                            fieldName="user"
                            labelName="name"
                            valueName="login"
                          />
                        )}
                        control={control}
                        name="user"
                        defaultValue=""
                        rules={{ required: 'Usuário é obrigatório!' }}
                      />
                      <ErrorMessage
                        errors={errors}
                        name="user"
                        render={({ message }) => errorFormMessage(message)}
                      />
                    </Col>
                  </Row>
                )}
              </>
            )}

            <Button
              color="danger"
              data-dismiss="modal"
              type="button"
              onClick={toggleModal}
              style={buttonStyle(systemConfiguration.cancelation_button_color)}
            >
              Fechar
            </Button>

            <Button
              color="primary"
              type="submit"
              style={buttonStyle(systemConfiguration.confirmation_button_color)}
            >
              {transferToSelf ? 'Transferir para si mesmo' : 'Transferir'}
            </Button>
          </Form>
        </ModalBody>
      </Modal>
    </>
  );
};

export default TransferConversation;
